import { Heart, Lightbulb, Users } from 'lucide-react'

import { ButtonLink } from '@/components/ButtonLink'
import { DonationPanel } from '@/components/DonationPanel'
import { InnerHero } from '@/components/InnerHero'
import { Marquee } from '@/components/Marquee'
import { Reveal } from '@/components/Reveal'
import { SectionIntro } from '@/components/SectionIntro'
import { storyTimeline } from '@/data/site'

const values = [
  {
    icon: Heart,
    title: 'Amor que actúa',
    description: 'La esperanza se vuelve concreta cuando inspira decisiones, cuidado y constancia.',
  },
  {
    icon: Lightbulb,
    title: 'Información abierta',
    description: 'Compartir lo aprendido puede ahorrar tiempo, dudas y soledad a otra familia.',
  },
  {
    icon: Users,
    title: 'Comunidad real',
    description: 'Nadie debería cargar en silencio con un proceso tan complejo y transformador.',
  },
]

export function StoryPage() {
  return (
    <>
      <InnerHero
        eyebrow="El origen del movimiento"
        title="Nuestra historia"
        description="Una historia atravesada por un accidente, una esperanza feroz y la certeza de que compartir el camino puede cambiarlo todo."
      />

      <Marquee />

      <section className="section-space" aria-labelledby="story-lead-title">
        <div className="container-wide story-lead-grid">
          <Reveal className="portrait-stack">
            <img
              src="/assets/images/noa-mama.webp"
              alt="Noa y su mamá mirándose de cerca"
              width="1200"
              height="1600"
            />
            <p className="portrait-caption">
              <span className="marquee-dot" aria-hidden="true" />
              Noa y Ana · avanzar juntas
            </p>
          </Reveal>

          <div>
            <Reveal>
              <p className="eyebrow">13 de septiembre de 2022</p>
              <h2 className="section-title" id="story-lead-title">
                La vida cambió en un instante.
              </h2>
              <div className="body-copy mt-8">
                <p>
                  Noa tenía un año cuando sufrió un accidente en una piscina. Después
                  de una larga reanimación y de ser estabilizada en el hospital, su
                  familia recibió un diagnóstico que transformó por completo sus
                  planes: una lesión cerebral severa.
                </p>
                <p>
                  Al volver a casa comenzó otro tipo de urgencia. Había que aprender
                  sobre terapias, equipo, especialistas y cuidados mientras se
                  sostenía la vida familiar. Las respuestas no estaban reunidas en un
                  solo lugar.
                </p>
                <p>
                  Una red de personas ayudó a abrir posibilidades. De esa experiencia
                  nació la decisión de compartir lo aprendido y acercarlo a quienes
                  apenas empiezan un camino similar.
                </p>
              </div>
            </Reveal>

            <div className="timeline">
              {storyTimeline.map((item, index) => (
                <Reveal delay={index * 0.06} key={item.title}>
                  <article className="timeline-item">
                    <span className="timeline-index">0{index + 1}</span>
                    <div>
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                    </div>
                  </article>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section-space bg-lilac-soft" aria-labelledby="values-title">
        <div className="container-wide">
          <SectionIntro
            align="center"
            eyebrow="Lo que nos mueve"
            title="Una experiencia personal convertida en acción colectiva."
            description="El movimiento existe para reducir distancias: entre una pregunta y una respuesta, entre una familia y otra, entre el miedo y una nueva posibilidad."
          />
          <div className="impact-grid">
            {values.map((value, index) => {
              const Icon = value.icon

              return (
                <Reveal delay={index * 0.1} key={value.title}>
                  <article className="impact-card">
                    <span className="impact-index">0{index + 1}</span>
                    <span className="impact-icon">
                      <Icon aria-hidden="true" size={32} strokeWidth={1.5} />
                    </span>
                    <h3>{value.title}</h3>
                    <p>{value.description}</p>
                  </article>
                </Reveal>
              )
            })}
          </div>
          <Reveal className="mt-10 flex justify-center">
            <ButtonLink href="/ayudanos/" variant="dark">
              Súmate al movimiento
            </ButtonLink>
          </Reveal>
        </div>
      </section>

      <DonationPanel />
    </>
  )
}
